import axios from 'axios';
import * as api from './constants';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getItemByIdV1(id, params) {
  return axios
    .get(api.ITEM_BY_ID_NEW(id), { params, withCredentials: true })
    .catch(reject);
}

/**
 * Get list item from server
 * TODO change to getItemsV2
 */
export function getItems(queryparams) {
  return axios
    .get(`${api.ITEMS_NEW}`, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      params: { ...queryparams, is_mobile: false, size: 50 },
      withCredentials: true,
    })
    .catch(reject);
}

export function getItemsV2(params) {
  return axios
    .get(`${api.V2_ITEMS}`, { params, withCredentials: true })
    .catch(reject);
}

export function getItemsV1(queryparams, headers?) {
  return axios
    .get(`${api.ITEMS_NEW}`, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      params: { ...queryparams, is_mobile: false, size: 50 },
      headers,
      withCredentials: true,
    })
    .catch(reject);
}
